<div class="container-fluid bg-white border card-v">
  <div class="row mb-2">
    <div class="col-xl-6 col-10">
      <h3>Compare Multiple Universities</h3>
    </div>
    <div class="col-xl-6 col-2 mb-2 mt-2">
      <div class="hoursadd d-flex align-items-center justify-content-end">
        <div class="lgout header">
          <div class="flex flex-row-reverse items-center">
            <ul class="d-flex align-items-center m-0 p-0">
              <li class="dropup">
                <a (click)="duplicateresidency()" class="cursor-pointer"
                  ><img
                    src="https://cdn.virtueanalytics.com/cache/shorting-icon-top5.png"
                /></a>

                <div class="dropup-content cost-list">
                  <ul
                    x-transition:leave="transition ease-in duration-150"
                    x-transition:leave-start="opacity-100"
                    x-transition:leave-end="opacity-0"
                    class="absolute cursor-pointer right-0 w-56 p-2 mt-2 bg-gray-100 border-gray-400 shadow space-y-2 text-gray-600 bg-white border border-gray-100 rounded-md shadow-md dark:border-gray-700 dark:text-gray-300 dark:bg-gray-700"
                    aria-label="submenu"
                    style="z-index: 1"
                  >
                    <li
                      class="flex cursor-pointer"
                      *ngFor="let sortBy of collegeSortByList"
                    >
                      <span
                        (click)="ChangeSorting(sortBy.value)"
                        [ngClass]="
                          sortBy.value == collegeSortBy ? 'active' : ''
                        "
                      >
                        {{ sortBy.label }}</span
                      >
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row college-cd mb-4">
    <div
      class="col-md-3 mb-4"
      *ngFor="let clg of collegeCardViewList; let index = index"
    >
      <div class="card" style="min-height: 260px">
        <div class="card-head">
          <ng-container *ngIf="clg?.summaryData?.imageAvailable" ;>
            <img [src]="clg?.summaryData?.collegeProfileIcon" />
          </ng-container>
          <ng-container *ngIf="clg?.summaryData?.imageAvailable == false">
            <!-- *ngIf="college.imageAvailable == false"
            id="randomcolor" -->
            <!-- [style.backgroundColor]="college.defaultLabelColor" -->
            <span
              [style.backgroundColor]="clg?.summaryData?.defaultLabelColor"
              style="
                display: inline-block;
                border-radius: 50%;
                width: 60px;
                height: 60px;
                border: 1px solid #f26722;
                margin-right: 10px;
                text-align: center;
                padding: 19px 0px 6px 0px;
                color: #103677 !important;
                font-weight: bold;
              "
            >
              {{ getFirstAndLastWords(clg?.dropDownData.name) }}
            </span>
            <!-- <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="#f26722"
              style="
                display: inline-block;
                border-radius: 50%;
                width: 60px;
                height: 60px;
                border: 1px solid #f26722;
                margin-right: 10px;
              "
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 21v-8.25M15.75 21v-8.25M8.25 21v-8.25M3 9l9-6 9 6m-1.5 12V10.332A48.36 48.36 0 0012 9.75c-2.551 0-5.056.2-7.5.582V21M3 21h18M12 6.75h.008v.008H12V6.75z"
              />
            </svg> -->
          </ng-container>
          <!-- <ng-container
            *ngIf="clg?.summaryData?.collegeProfileIcon; else defaultIcon"
          >
            <img [src]="clg?.summaryData?.collegeProfileIcon" />
          </ng-container>
          <ng-template #defaultIcon>
            <svg
              class="default-icon"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="#f26722"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 21v-8.25M15.75 21v-8.25M8.25 21v-8.25M3 9l9-6 9 6m-1.5 12V10.332A48.36 48.36 0 0012 9.75c-2.551 0-5.056.2-7.5.582V21M3 21h18M12 6.75h.008v.008H12V6.75z"
              />
            </svg>
          </ng-template> -->
          <h5
            [ngClass]="
              checkOutStateGridData(clg, index) == true
                ? 'merit-GridNotUsed'
                : ''
            "
            class="card-title"
            (click)="OpenUniversitySummaryDialog(clg)"
            style="cursor: pointer"
          >
            {{ clg.dropDownData.name }}
            <!-- (click)="select()"  -->
            <!-- <br /> -->
            <span
              class="college-Rank mr-2"
              *ngIf="clg?.dropDownData?.collegeRankInUS"
            >
              Rank: {{ clg?.dropDownData?.collegeRankInUS }}</span
            >
            <!-- SELECTED NAMWE -->
            <!-- <div
              class="selected-label gold-l silver-l"
              [ngClass]="FillHeartColor(clg)"
            >
              {{ selectedText(clg) == "thclose" ? "" : selectedText(clg) }}
            </div> -->
          </h5>
          <!-- Add hearts -->
          <!-- (click)="openPopup(clg?.dropDownData?.ipedsId, index)" -->
          <!-- (mouseenter)="openPopup(clg?.dropDownData?.ipedsId, index)"
          (mouseleave)="closePopup()" -->
          <svg
            [ngClass]="FillHeartColor(clg)"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="w-6 h-6"
            style="
              position: absolute;
              width: 16px;
              top: 6px;
              right: 30px;
              cursor: pointer;
            "
            [tooltip]="selectedText(clg) == 'thclose' ? '' : selectedText(clg)"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M17.593 3.322c1.1.128 1.907 1.077 1.907 2.185V21L12 17.25 4.5 21V5.507c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0 1 11.186 0Z"
            />
          </svg>
          <div
            class="wish-icon"
            (mouseenter)="openPopup(clg?.dropDownData?.ipedsId, index, $event)"
            (mouseleave)="closePopup()"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-6 h-6"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M17.593 3.322c1.1.128 1.907 1.077 1.907 2.185V21L12 17.25 4.5 21V5.507c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0 1 11.186 0Z"
              />
            </svg>

            <svg
              #toggleButton
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-6 h-6 heart-icon-class"
              style="
                position: absolute;
                width: 22px;
                top: 3px;
                right: 5px;
                cursor: pointer;
              "
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 6.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 12.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 18.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Z"
              />
            </svg>

            <!-- <svg
              #toggleButton
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              [ngClass]="FillHeartColor(clg)"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-6 h-6 heart-icon-class"
              style="
                position: absolute;
                width: 22px;
                top: 3px;
                right: 5px;
                cursor: pointer;
              "
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z"
              />
            </svg> -->
            <!-- " -->

            <ng-container *ngIf="selectedCollegeIndex === index && showPopup">
              <div id="watchlist">
                <div
                  class="cost-list your-container-class"
                  (mouseenter)="
                    openPopup(clg?.dropDownData?.ipedsId, index, $event)
                  "
                >
                  <ul
                    class=""
                    x-transition:leave="transition ease-in duration-150"
                    x-transition:leave-start="opacity-100"
                    x-transition:leave-end="opacity-0"
                    class="absolute cursor-pointer right-0 top-10 w-56 p-2 mt-2 bg-gray-100 border-gray-400 shadow space-y-2 text-gray-600 bg-white border border-gray-100 rounded-md shadow-md dark:border-gray-700 dark:text-gray-300 dark:bg-gray-700"
                    aria-label="submenu"
                  >
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        (click)="close(clg)"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="w-6 h-6"
                        style="
                          position: absolute;
                          width: 20px;
                          top: 3px;
                          right: 5px;
                        "
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99"
                        />
                      </svg>
                      <!-- <button
                        type="button"
                        class="close pull-right close-profile"
                        aria-label="close"
                      >
                        <span aria-hidden="true">×</span>
                      </button> -->
                    </div>

                    <li
                      class=""
                      (mouseenter)="
                        openPopup(clg?.dropDownData?.ipedsId, index, $event)
                      "
                      *ngFor="let option of addWatchlistMemberOptions"
                    >
                      <label>
                        <!-- isSelected(
                          option.value,
                          clg?.dropDownData?.ipedsId,
                          index
                        ) -->
                        <input
                          type="radio"
                          name="level"
                          [value]="option.value"
                          [checked]="isSelected(option.value, clg)"
                          (change)="
                            selectLevel(
                              $event,
                              $event.target.value,
                              clg?.dropDownData?.ipedsId,
                              index
                            )
                          "
                        />
                        {{ option.label }}
                      </label>
                    </li>
                  </ul>
                </div>
              </div>
              <!-- <h3>Choose a level:</h3> -->
            </ng-container>
          </div>
          <!-- (mouseenter)="cancelClose()"
            (mouseleave)="closePopup()" -->
          <!-- <ng-container class="dropup-content cost-list" *ngIf="showPopup">
              <h3>Choose a level:</h3>
              <ul>
                <li *ngFor="let option of addWatchlistMemberOptions">
                  <label>
                    <input
                      type="radio"
                      name="level"
                      [value]="option.value"
                      (change)="selectLevel($event.target.value)"
                    />
                    {{ option.label }}
                  </label>
                </li>
              </ul>
            </ng-container> -->

          <!-- 
          <span id="imagewatchpopup">
            <img
              src="assets/images/vido-save.png"
              (click)="AddWatchList(clg?.dropDownData?.ipedsId)"
            />
          </span> -->
        </div>
        <div class="card-body">
          <h6 class="card-subtitle mb-2 text-muted">
            <!-- {{
              getOutOfPocketAmount(clg)
                ? (getOutOfPocketAmount(clg)
                  | currency : "$ " : "symbol" : "1.0-0")
                : "-"
            }} -->

            {{
              clg?.dropDownData?.outOfPocketCost
                ? (clg?.dropDownData?.outOfPocketCost
                  | currency : "$ " : "symbol" : "1.0-0")
                : "-"
            }}
            <!-- <span>(Based on IPEDS COA)</span> -->
          </h6>
          <p class="card-text">Approx Out of Pocket Cost</p>

          <!-- <ng-container
            *ngFor="
              let cost of clg.dropDownData['npcCollegeCostProfile'] | keyvalue;
              let i = index
            "
          > -->
          <h6 class="card-subtitle mb-2 text-muted">
            {{
              getCostOfAttendanceHeaderAmount1(clg, index)
                ? (getCostOfAttendanceHeaderAmount1(clg, index)
                  | currency : "$ " : "symbol" : "1.0-0")
                : "-"
            }}
            <ng-container *ngIf="getErrorInCollegeCost(clg, index) == true">
              <span
                class="t-demo__btn"
                ngxTippy
                [ngxTippy]="htmlTemplate"
                [tippyName]="'t_errorInCollegeCost' + index"
                [tippyProps]="templateRef"
                class="text-success ml-1 labeltoolTip-hover"
              >
                <img
                  _ngcontent-ucv-c224=""
                  src="https://cdn.virtueanalytics.com/cache/exclamation-top5-ic.png"
                  alt="warning-emoji"
                  class="cursor-pointer"
                />
              </span>
              <template #htmlTemplate>
                <div class="t-template" #tippyTemplatePassElement>
                  <p
                    class="t-template__info text-left"
                    style="color: #fff !important"
                  >
                    We have identified some discrepancies in the reported costs
                    for this college.
                  </p>
                </div>
              </template>
            </ng-container>
          </h6>
          <!-- </ng-container> -->

          <p class="card-text">Cost of Attendance</p>

          <h6 class="card-subtitle mb-2 text-muted">
            <!-- {{
              getMeritHeaderAmount1(
                clg?.dropDownData["result"].totalGrant?.amount,
                index
              )
                ? (getMeritHeaderAmount1(
                    clg?.dropDownData["result"].totalGrant.amount,
                    index
                  ) | currency : "$ " : "symbol" : "1.0-0")
                : "-"
            }} -->
            {{
              clg?.dropDownData?.totalGrant
                ? (clg?.dropDownData?.totalGrant
                  | currency : "$ " : "symbol" : "1.0-0")
                : "-"
            }}

            <!-- <ng-container *ngIf="checkOutStateGridData(clg, index) ==true">
              <span
                class="t-demo__btn unique_span"
                ngxTippy
                [ngxTippy]="htmlTemplate"
                [tippyName]="'outStateGridNotUsed_Card_view' + index"
                [tippyProps]="templateRef"
                class="text-success ml-1 labeltoolTip-hover"
              >
              <svg
              
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-6 h-6 cursor-pointer"
              style="display: inline-block; width: 17px; color: rgb(52, 170, 52)"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
              /></svg>
              </span>
              <template #htmlTemplate>
                <div class="t-template" #tippyTemplatePassElement>
                  <p class="t-template__info text-left" style="color: #fff !important;">
                    The grants for this college are calculated using  grant data for in-state students, actual grants may vary.

                  </p>
                </div>
              </template>
            </ng-container> -->
            <!-- <ng-container *ngIf="checkOutStateGridData(clg,index)==true">

              <span>
                <svg
                
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-6 h-6"
                style="display: inline-block; width: 17px; color: rgb(52, 170, 52)"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
                /></svg>
              </span>
         
           
            </ng-container>  -->
          </h6>
          <p class="card-text">Total Scholarships & Aid</p>
        </div>
      </div>
    </div>
    <!-- <div class="col ">
        <div class="card">
            <div class="card-head">
                <img src="https://tech.virtueanalytics.com/v-api/fileStorage/download/7b1132c2-ded6-453e-94a0-7b7ae5449266">
                <h5 class="card-title">Minnesota State University Moorhead  </h5>
              </div>
            <div class="card-body">
              <h6 class="card-subtitle mb-2 text-muted">$ 25,711  <span>(Based on College NPC)</span></h6>
              <p class="card-text">Approx Out of Pocket Cost</p>
              
              <h6 class="card-subtitle mb-2 text-muted">$ 23,884</h6>
              <p class="card-text">  Cost of Attendance </p>

              <h6 class="card-subtitle mb-2 text-muted">$ 17,695</h6>
              <p class="card-text"> Merit & Gift Aid</p>

            </div>
          </div>    
    </div>
    <div class="col ">
        <div class="card">
            <div class="card-head">
                <img src="https://tech.virtueanalytics.com/v-api/fileStorage/download/7b1132c2-ded6-453e-94a0-7b7ae5449266">
                <h5 class="card-title">Minnesota State University Moorhead  </h5>
              </div>
            <div class="card-body">
              <h6 class="card-subtitle mb-2 text-muted">$ 25,711  <span>(Based on College NPC)</span></h6>
              <p class="card-text">Approx Out of Pocket Cost</p>
              
              <h6 class="card-subtitle mb-2 text-muted">$ 23,884</h6>
              <p class="card-text">  Cost of Attendance </p>

              <h6 class="card-subtitle mb-2 text-muted">$ 17,695</h6>
              <p class="card-text"> Merit & Gift Aid</p>

            </div>
          </div>    
    </div>
    <div class="col ">
        <div class="card">
            <div class="card-head">
                <img src="https://tech.virtueanalytics.com/v-api/fileStorage/download/7b1132c2-ded6-453e-94a0-7b7ae5449266">
                <h5 class="card-title">Minnesota State University Moorhead  </h5>
              </div>
            <div class="card-body">
              <h6 class="card-subtitle mb-2 text-muted">$ 25,711  <span>(Based on College NPC)</span></h6>
              <p class="card-text">Approx Out of Pocket Cost</p>

              <h6 class="card-subtitle mb-2 text-muted">$ 23,884</h6>
              <p class="card-text">  Cost of Attendance </p>

              <h6 class="card-subtitle mb-2 text-muted">$ 17,695</h6>
              <p class="card-text"> Merit & Gift Aid</p>
            </div>
          </div>    
    </div>
    <div class="col ">
        <div class="card">
            <div class="card-head">
                <img src="https://tech.virtueanalytics.com/v-api/fileStorage/download/7b1132c2-ded6-453e-94a0-7b7ae5449266">
                <h5 class="card-title">Minnesota State University Moorhead  </h5>
              </div>
            <div class="card-body">
              <h6 class="card-subtitle mb-2 text-muted">$ 25,711  <span>(Based on College NPC)</span></h6>
              <p class="card-text">Approx Out of Pocket Cost</p>

              <h6 class="card-subtitle mb-2 text-muted">$ 23,884</h6>
              <p class="card-text">  Cost of Attendance </p>

              <h6 class="card-subtitle mb-2 text-muted">$ 17,695</h6>
              <p class="card-text"> Merit & Gift Aid</p>
            </div>
          </div>    
    </div> -->
  </div>
</div>
